import EntitySelectorGrid from './EntitySelectorGrid';

export default EntitySelectorGrid;
